import React from 'react'
import PetitionSearch from '../../components/petitions/PetitionSearch/PetitionSearch'

const PetitionSearchPage = () => {
  return (
    <div><PetitionSearch /></div>
  )
}

export default PetitionSearchPage